"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfKnownError = exports.MetamaskError = exports.GrpcError = void 0;
var _API = require("./API");
var _validationError = _interopRequireDefault(require("./validationError"));
var _BlockChainError = _interopRequireDefault(require("./BlockChainError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const checkIfKnownError = error => error instanceof _API.APIError || error instanceof _validationError.default || error instanceof _BlockChainError.default || error instanceof GrpcError || error instanceof MetamaskError;
exports.checkIfKnownError = checkIfKnownError;
class GrpcError extends Error {
  constructor(message) {
    super(message);
    this.name = "GrpcError";
  }
}
exports.GrpcError = GrpcError;
class MetamaskError extends Error {
  constructor(message) {
    super(message);
    this.name = "MetamaskError";
  }
}
exports.MetamaskError = MetamaskError;